<template>
  <div class="verification-form-risk-assmnt">
    <div class="verification-cdd-form__questions-list">
      <h3 class="verification-cdd-form__title">
        {{ "verification-form-risk-assmnt.title" | globalize }}
      </h3>

      <div class="verification-cdd-form__wrp">
        <button
          v-ripple
          @click.self.prevent="setRisk(true,'lowRisk')"
          class="app__button-raised"
          :class="{
            'app__button-raised--outline': !form.lowRisk,
          }"
          :disabled="isDisabled"
        >
          {{ 'verification-form-risk-assmnt.btn-low-risk' | globalize }}
        </button>
        <button
          v-ripple
          @click.self.prevent="setRisk(true,'generalRisk')"
          class="app__button-raised"
          :class="{
            'app__button-raised--outline': !form.generalRisk,
          }"
          :disabled="isDisabled"
        >
          {{ 'verification-form-risk-assmnt.btn-general-risk' | globalize }}
        </button>
        <button
          v-ripple
          @click.self.prevent="setRisk(true,'highRisk')"
          class="app__button-raised app__button-raised--danger"
          :class="{
            'app__button-raised--danger--outline': !form.highRisk,
          }"
          :disabled="isDisabled"
        >
          {{ 'verification-form-risk-assmnt.btn-high-risk' | globalize }}
        </button>
      </div>

      <div class="verification-cdd-form__fields-wrp">
        <textarea-field
          v-model="form.comments"
          @input="former.setAttr('riskAssmnt.comments', form.comments)"
          :error-message="getFieldErrorMessage('form.comments')"
          :label="
            'verification-form-risk-assmnt.lbl-comments' | globalize"
          :disabled="isDisabled"
        />
        <div class="verification-cdd-form__row">
          <textarea-field
            class="
              verification-cdd-form__subscriber-field
              app-list-filters__field"
            :value="form.subscriber"
            :label="
              'verification-form-risk-assmnt.lbl-cdd-signature' | globalize"
            :rows="6"
            disabled
          />
          <input-field
            class="verification-cdd-form__date-field app-list-filters__field"
            :value="form.signatureDate | formatDate"
            :label="'verification-form-risk-assmnt.lbl-date' | globalize"
            disabled
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VerificationCDDFormer } from '@/js/formers/VerificationCDDFormer'
import { VerificationBDDFormer } from '@/js/formers/VerificationBDDFormer'
import { DateUtil } from '@/js/utils'

import FormMixin from '@/vue/mixins/form.mixin'
import { required } from '@validators'
import { vuexTypes } from '@/vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'verification-form-risk-assmnt',
  mixins: [ FormMixin ],
  props: {
    former: {
      type: [VerificationCDDFormer, VerificationBDDFormer],
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      DateUtil,
      form: {
        comments: this.former.attrs.riskAssmnt.comments,
        subscriber: this.former.attrs.riskAssmnt.subscriber,
        signatureDate: this.former.attrs.riskAssmnt.signatureDate,
        lowRisk: this.former.attrs.riskAssmnt.lowRisk,
        generalRisk: this.former.attrs.riskAssmnt.generalRisk,
        highRisk: this.former.attrs.riskAssmnt.highRisk,
      },
    }
  },
  validations () {
    return {
      form: {
        comments: { required },
      },
    }
  },

  computed: {
    ...mapGetters([
      vuexTypes.accountAddress,
      vuexTypes.account,
    ]),
  },

  created () {
    if (!this.form.signatureDate) {
      this.setSignatureDate()
    }
    if (!this.form.subscriber) {
      this.setSubscriber()
    }
  },

  methods: {
    setRisk (val, key) {
      this.form[key] = val
      this.former.setAttr(`riskAssmnt.${key}`, val)

      switch (key) {
        case 'lowRisk':
          this.form.generalRisk = false
          this.form.highRisk = false
          this.former.setAttr(`riskAssmnt.generalRisk`, false)
          this.former.setAttr(`riskAssmnt.highRisk`, false)
          break
        case 'generalRisk':
          this.form.lowRisk = false
          this.form.highRisk = false
          this.former.setAttr(`riskAssmnt.lowRisk`, false)
          this.former.setAttr(`riskAssmnt.highRisk`, false)
          break
        case 'highRisk':
          this.form.lowRisk = false
          this.form.generalRisk = false
          this.former.setAttr(`riskAssmnt.lowRisk`, false)
          this.former.setAttr(`riskAssmnt.generalRisk`, false)
          break
        default:
          break
      }
    },
    setSignatureDate () {
      this.former.setAttr('riskAssmnt.signatureDate', this.DateUtil.now)
      this.form.signatureDate = this.DateUtil.now
    },
    setSubscriber () {
      let subscriber = `\nid: ${this.account.id}\naddress: ${this.accountAddress}\n`

      const { general } = this.account

      if (general.fullName) {
        subscriber += `name: ${general.fullName}`
      } else if (general.firstName || general.lastName) {
        subscriber += `name: ${general.firstName}${general.lastName}`
      }

      this.former.setAttr('riskAssmnt.subscriber', subscriber)
      this.form.subscriber = subscriber
    },
  },
}
</script>
